<template>
  <div>
    <div class="vx-row m-2">
      <div class="router-header flex flex-wrap items-center mb-6 mt-5">
        <div class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light">
          <h2 class="mb-1">{{ $t('users') }}</h2>
        </div>
      </div>
    </div>
    <vs-card class="px-10 py-5">
      <div>
        <vs-table maxHeight="460px" 
            search
            class="static" 
            :max-items="descriptionItems[0]"
            description
            :description-items="descriptionItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
            pagination 
            :data="users">
          <template slot="header">
            <vs-button class="py-2 px-5 h7 mb-3" color="#0066cc" type="filled" icon-pack="feather" icon="icon-user-plus"  @click="$router.push('/create-user')"> {{ $t("addUser") }}</vs-button>
          </template>
          <template slot="thead">
            <vs-th sort-key="id">
              {{ $t("RefineryTable.Id") }}
            </vs-th>
            <vs-th sort-key="username">
              {{ $t("profilePage.username") }}
            </vs-th>
            <vs-th>
              {{ $t("profilePage.firstName") }}
            </vs-th>
            <vs-th>
              {{ $t("profilePage.lastName") }}
            </vs-th>
            <vs-th>
              {{ $t("profilePage.email") }}
            </vs-th>
            <vs-th></vs-th>
            <vs-th></vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ tr.index+1 }}
              </vs-td>
              <vs-td>
                {{ data[indextr].username }}
              </vs-td>
              <vs-td>
                {{ data[indextr].firstName }}
              </vs-td>
              <vs-td>
                {{ data[indextr].lastName }}
              </vs-td>
              <vs-td>
                {{ data[indextr].email }}
              </vs-td>
              <vs-td style="width: 50px;">
                <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-edit"  @click="editUser(data[indextr].username)"></vs-button>
              </vs-td>
              <vs-td style="width: 50px;">
                <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2"  @click="openConfirm(data[indextr].username)"></vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-card>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import { isEmpty } from "lodash";
import {OIL_TYPE} from "../../constant/index";

export default {
  name: "Users",
  data() {
    return {
      descriptionItems: [10,25,50,100],
    };
  },
  watch: {
    users() {
      for (let i = 0; i < this.users.length; i++) {
        this.users[i].index = i;
      }
    },
  },
  computed: {
    ...mapState({
      users: (state) => state.profile.users,
    }),
  },
  mounted() {
    this.$store.dispatch("activeOilCard", OIL_TYPE.ALL);
    this.getUsers();
  },
  methods: {
    getUsers() {
      this.$store.dispatch("getUsers");
    },
    setDateFormat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    editUser(username){
      localStorage.setItem("editUser", username);
      this.$router.push("/edit-users");
    },
    openConfirm(username) {
        this.$fire({
          type: "question",
          title: "คุณต้องการลบผู้ใช้งาน?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: `Yes`,
        }).then(async (result) => {
           const status = await this.getErrorStatus;
          if (result.value && result.dismiss!='cancel') {
            await this.$store.dispatch("deleteUser", username);
            if (isEmpty(status)) {
              this.$fire({
                type: "success",
                title: "ลบผู้ใช้งานสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              });
              location.reload();
            } else {
              this.$fire({
                type: "error",
                title: "ลบผู้ใช้งานไม่สำเร็จ",
                text: "Something went wrong!",
              });
            }
          }
        });
    },
    deleteUser(username){
      this.$store.dispatch("deleteUser", username)
    }
  },
};
</script>

<style>
.tableship {
  height: 100%;
}
@media print {
  #selecttime {
    display: none;
  }
}
</style>
